module.exports = __webpack_public_path__ + "media/images/propaganda-4bfbf4a34f6543390e2f4fe646d48604.png";